import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homeseven-about',
  templateUrl: './homeseven-about.component.html',
  styleUrls: ['./homeseven-about.component.scss']
})
export class HomesevenAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
